<template>
  <router-link :to="`/research/${data.id}`">
    <div class="home-research-item flex-col">
      <img src="../../../assets/images/shadom.png" alt class="shadow" />
      <div
        class="cover"
        :style="`background:url(${data.cover_url}) no-repeat center center / cover`"
      >
        <div v-if="data.tag" class="icon-type" v-text="data.tag"></div>
      </div>
      <div class="home-research-title" v-text="data.topic"></div>
    </div>
  </router-link>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "HomeResearchBlock",
  props: {
    data: {
      type: Object,
      defalut: () => {
        return {};
      },
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.home-research-item {
  width: 251px;
  height: 434px;
  background: #ffffff;
  position: relative;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0px 0px 20px 0px rgba(81, 85, 106, 0.13);
  }
  .shadow {
    position: absolute;
    left: 45%;
  }
  .cover {
    width: 251px;
    height: 328px;
    border-radius: 5px;
    object-fit: contain;
    position: relative;
  }
  .icon-type {
    position: absolute;
    z-index: 2;
    height: 36px;
    background: #173b72;
    border-radius: 0px 5px 0px 26px;
    background: rgba(23, 59, 114, 0.4);
    padding: 0 15px 0 18px;
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    line-height: 36px;
    top: 0;
    right: 0;
  }
  .home-research-title {
    width: 231px;
    height: 66px;
    font-size: 16px;
    font-weight: 500;
    color: #423e3d;
    line-height: 22px;
    overflow: hidden;
    margin: 20px 10px;
    overflow: hidden;
    font-weight: 600;
  }
}
</style>
